var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useRef } from 'react';
import { sanitizeName, sanitizeDescription, sanitizeWineType, sanitizeRegion, sanitizeAlcoholContent, sanitizeYear, sanitizePrice, escapeHtml } from '../utils/sanitization';
import './AdminPanel.css';
import { ApiProductService } from '../services/apiService';
import { getActivePromo, formatEUR, formatPromoDate } from '../utils/promo';
import PromoFields, { emptyPromoForm, promoFormFromProduct, validatePromoForm, confirmLongPromo, appendPromoToFormData } from './PromoFields';
import PromotionsManager from './PromotionsManager';
var emptyEventForm = function () { return ({
    name: '',
    nameBg: '',
    date: '',
    time: '',
    town: '',
    townBg: '',
    location: '',
    locationBg: '',
    link: '',
    linkType: 'website',
}); };
var AdminPanel = function (_a) {
    var onClose = _a.onClose;
    var _b = useState('add'), activeTab = _b[0], setActiveTab = _b[1];
    var _c = useState([]), products = _c[0], setProducts = _c[1];
    var _d = useState(false), loading = _d[0], setLoading = _d[1];
    var _e = useState(''), message = _e[0], setMessage = _e[1];
    var _f = useState(''), error = _f[0], setError = _f[1];
    // Initialize API service
    var apiService = new ApiProductService();
    // Events state
    var _g = useState([]), events = _g[0], setEvents = _g[1];
    var _h = useState(false), eventsLoading = _h[0], setEventsLoading = _h[1];
    var _j = useState(''), eventsMessage = _j[0], setEventsMessage = _j[1];
    var _k = useState(''), eventsError = _k[0], setEventsError = _k[1];
    var _l = useState(emptyEventForm()), eventForm = _l[0], setEventForm = _l[1];
    var _m = useState(null), editingEvent = _m[0], setEditingEvent = _m[1];
    // Form states
    var _o = useState({
        name: '',
        nameBg: '',
        year: new Date().getFullYear(),
        description: '',
        descriptionBg: '',
        type: 'Red Wine',
        region: 'Bulgaria',
        alcoholContent: '13.0%',
        servingTemperature: '16-18°C',
        priceEUR: 18.00,
        image: null
    }), formData = _o[0], setFormData = _o[1];
    var _p = useState(emptyPromoForm()), promoForm = _p[0], setPromoForm = _p[1];
    var _q = useState(null), editingProduct = _q[0], setEditingProduct = _q[1];
    var fileInputRef = useRef(null);
    // Handle form input changes
    var handleInputChange = function (e) {
        var _a = e.target, name = _a.name, value = _a.value;
        var inputValue;
        // Only sanitize numeric fields during typing, preserve text input as-is
        switch (name) {
            case 'year':
                // Allow empty string or parse as number
                inputValue = value === '' ? '' : (parseFloat(value) || '');
                break;
            case 'priceEUR':
                inputValue = sanitizePrice(parseFloat(value) || 0);
                break;
            default:
                // For text fields, store the raw input and sanitize only on submission
                inputValue = value;
        }
        setFormData(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[name] = inputValue, _a)));
        });
    };
    // Handle file selection
    var handleFileChange = function (e) {
        var _a;
        var file = (_a = e.target.files) === null || _a === void 0 ? void 0 : _a[0];
        if (file) {
            // Validate file type and size
            var allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp'];
            var maxSize = 5 * 1024 * 1024; // 5MB
            if (!allowedTypes.includes(file.type)) {
                setError('Invalid file type. Please select a JPG, PNG, GIF, or WebP image.');
                e.target.value = '';
                return;
            }
            if (file.size > maxSize) {
                setError('File size too large. Please select an image smaller than 5MB.');
                e.target.value = '';
                return;
            }
            setFormData(function (prev) { return (__assign(__assign({}, prev), { image: file })); });
            setError(''); // Clear any previous errors
        }
    };
    // Validate form data before submission
    var validateForm = function () {
        var _a, _b, _c, _d;
        if (!((_a = formData.name) === null || _a === void 0 ? void 0 : _a.trim())) {
            setError('Name (English) is required');
            return false;
        }
        if (!((_b = formData.nameBg) === null || _b === void 0 ? void 0 : _b.trim())) {
            setError('Name (Bulgarian) is required');
            return false;
        }
        if (!((_c = formData.description) === null || _c === void 0 ? void 0 : _c.trim())) {
            setError('Description (English) is required');
            return false;
        }
        if (!((_d = formData.descriptionBg) === null || _d === void 0 ? void 0 : _d.trim())) {
            setError('Description (Bulgarian) is required');
            return false;
        }
        if (!formData.image) {
            setError('Product image is required');
            return false;
        }
        return true;
    };
    var validatePromo = function () {
        var promoError = validatePromoForm(promoForm, formData.priceEUR || 0);
        if (promoError) {
            setError(promoError);
            return false;
        }
        return confirmLongPromo(promoForm);
    };
    var appendPromo = function (body) { return appendPromoToFormData(body, promoForm); };
    // Handle form submission for adding product
    var handleSubmit = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var sanitizedData, formDataToSend, result, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    e.preventDefault();
                    if (!validateForm() || !validatePromo()) {
                        return [2 /*return*/];
                    }
                    setLoading(true);
                    setMessage('');
                    setError('');
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, 5, 6]);
                    sanitizedData = {
                        name: sanitizeName(formData.name || ''),
                        nameBg: sanitizeName(formData.nameBg || ''),
                        year: sanitizeYear(typeof formData.year === 'string' ? parseInt(formData.year) || new Date().getFullYear() : formData.year || new Date().getFullYear()),
                        description: sanitizeDescription(formData.description || ''),
                        descriptionBg: sanitizeDescription(formData.descriptionBg || ''),
                        type: sanitizeWineType(formData.type || 'Red Wine'),
                        region: sanitizeRegion(formData.region || ''),
                        alcoholContent: sanitizeAlcoholContent(formData.alcoholContent || ''),
                        servingTemperature: formData.servingTemperature || '16-18°C',
                        priceEUR: sanitizePrice(formData.priceEUR || 0)
                    };
                    formDataToSend = new FormData();
                    formDataToSend.append('name', sanitizedData.name);
                    formDataToSend.append('nameBg', sanitizedData.nameBg);
                    formDataToSend.append('year', sanitizedData.year.toString());
                    formDataToSend.append('description', sanitizedData.description);
                    formDataToSend.append('descriptionBg', sanitizedData.descriptionBg);
                    formDataToSend.append('type', sanitizedData.type);
                    formDataToSend.append('region', sanitizedData.region);
                    formDataToSend.append('alcoholContent', sanitizedData.alcoholContent);
                    formDataToSend.append('servingTemperature', sanitizedData.servingTemperature);
                    formDataToSend.append('priceEUR', sanitizedData.priceEUR.toString());
                    appendPromo(formDataToSend);
                    if (formData.image) {
                        formDataToSend.append('image', formData.image);
                    }
                    return [4 /*yield*/, apiService.addProduct(formDataToSend)];
                case 2:
                    result = _a.sent();
                    setMessage("Product \"".concat(result.name, "\" added successfully!"));
                    resetForm();
                    // Immediately refresh product list (bypasses cache, gets fresh S3 data)
                    console.log('🔄 [Frontend] Refreshing product list after add...');
                    return [4 /*yield*/, fetchProducts()];
                case 3:
                    _a.sent();
                    return [3 /*break*/, 6];
                case 4:
                    err_1 = _a.sent();
                    setError('Network error. Please try again.');
                    return [3 /*break*/, 6];
                case 5:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    // Validate update form data before submission
    var validateUpdateForm = function () {
        var _a, _b, _c, _d;
        console.log('🔍 [Frontend] Validating update form:', {
            name: formData.name ? "".concat(formData.name.length, " chars") : 'empty',
            nameBg: formData.nameBg ? "".concat(formData.nameBg.length, " chars") : 'empty',
            description: formData.description ? "".concat(formData.description.length, " chars") : 'empty',
            descriptionBg: formData.descriptionBg ? "".concat(formData.descriptionBg.length, " chars") : 'empty'
        });
        if (!((_a = formData.name) === null || _a === void 0 ? void 0 : _a.trim())) {
            setError('Name (English) is required');
            console.error('❌ [Frontend] Validation failed: Name (English) is missing');
            return false;
        }
        if (!((_b = formData.nameBg) === null || _b === void 0 ? void 0 : _b.trim())) {
            setError('Name (Bulgarian) is required');
            console.error('❌ [Frontend] Validation failed: Name (Bulgarian) is missing');
            return false;
        }
        if (!((_c = formData.description) === null || _c === void 0 ? void 0 : _c.trim())) {
            setError('Description (English) is required');
            console.error('❌ [Frontend] Validation failed: Description (English) is missing');
            console.log('Current description value:', formData.description);
            return false;
        }
        if (!((_d = formData.descriptionBg) === null || _d === void 0 ? void 0 : _d.trim())) {
            setError('Description (Bulgarian) is required');
            console.error('❌ [Frontend] Validation failed: Description (Bulgarian) is missing');
            return false;
        }
        console.log('✅ [Frontend] Validation passed');
        return true;
    };
    // Handle form submission for updating product
    var handleUpdate = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var sanitizedData, formDataToSend, token, response, result, productName, errorData, err_2;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    e.preventDefault();
                    if (!editingProduct)
                        return [2 /*return*/];
                    if (!validateUpdateForm() || !validatePromo()) {
                        return [2 /*return*/];
                    }
                    setLoading(true);
                    setMessage('');
                    setError('');
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 8, 9, 10]);
                    sanitizedData = {
                        name: sanitizeName(formData.name || ''),
                        nameBg: sanitizeName(formData.nameBg || ''),
                        year: sanitizeYear(typeof formData.year === 'string' ? parseInt(formData.year) || new Date().getFullYear() : formData.year || new Date().getFullYear()),
                        description: sanitizeDescription(formData.description || ''),
                        descriptionBg: sanitizeDescription(formData.descriptionBg || ''),
                        type: sanitizeWineType(formData.type || 'Red Wine'),
                        region: sanitizeRegion(formData.region || ''),
                        alcoholContent: sanitizeAlcoholContent(formData.alcoholContent || ''),
                        servingTemperature: formData.servingTemperature || '16-18°C',
                        priceEUR: sanitizePrice(formData.priceEUR || 0)
                    };
                    // Ensure all required fields are present
                    if (!sanitizedData.name || !sanitizedData.nameBg || !sanitizedData.description || !sanitizedData.descriptionBg) {
                        setError('All required fields must be filled');
                        setLoading(false);
                        return [2 /*return*/];
                    }
                    formDataToSend = new FormData();
                    formDataToSend.append('name', sanitizedData.name);
                    formDataToSend.append('nameBg', sanitizedData.nameBg);
                    formDataToSend.append('year', sanitizedData.year.toString());
                    formDataToSend.append('description', sanitizedData.description);
                    formDataToSend.append('descriptionBg', sanitizedData.descriptionBg);
                    formDataToSend.append('type', sanitizedData.type);
                    formDataToSend.append('region', sanitizedData.region);
                    formDataToSend.append('alcoholContent', sanitizedData.alcoholContent);
                    formDataToSend.append('servingTemperature', sanitizedData.servingTemperature);
                    formDataToSend.append('priceEUR', sanitizedData.priceEUR.toString());
                    appendPromo(formDataToSend);
                    if (formData.image) {
                        formDataToSend.append('image', formData.image);
                    }
                    // Debug: Log what we're sending
                    console.log('Sending update data:', {
                        id: editingProduct.id,
                        sanitizedData: sanitizedData,
                        hasImage: !!formData.image
                    });
                    token = localStorage.getItem('redaktor_token');
                    if (!token) {
                        setError('Authentication required. Please log in again.');
                        setLoading(false);
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, fetch("/api/products/".concat(editingProduct.id), {
                            method: 'PUT',
                            headers: {
                                'Authorization': "Bearer ".concat(token)
                            },
                            body: formDataToSend
                        })];
                case 2:
                    response = _b.sent();
                    if (!response.ok) return [3 /*break*/, 5];
                    return [4 /*yield*/, response.json()];
                case 3:
                    result = _b.sent();
                    console.log('✅ [Frontend] Update response:', result);
                    productName = ((_a = result === null || result === void 0 ? void 0 : result.product) === null || _a === void 0 ? void 0 : _a.name) || (result === null || result === void 0 ? void 0 : result.name) || (editingProduct === null || editingProduct === void 0 ? void 0 : editingProduct.name) || 'Unknown Product';
                    setMessage("Product \"".concat(productName, "\" updated successfully!"));
                    resetForm();
                    setEditingProduct(null);
                    // Immediately refresh product list (bypasses cache, gets fresh S3 data)
                    console.log('🔄 [Frontend] Refreshing product list after update...');
                    return [4 /*yield*/, fetchProducts()];
                case 4:
                    _b.sent();
                    return [3 /*break*/, 7];
                case 5: return [4 /*yield*/, response.json()];
                case 6:
                    errorData = _b.sent();
                    console.error('Update failed:', errorData); // Debug log
                    setError(errorData.message || 'Failed to update product');
                    _b.label = 7;
                case 7: return [3 /*break*/, 10];
                case 8:
                    err_2 = _b.sent();
                    setError('Network error. Please try again.');
                    return [3 /*break*/, 10];
                case 9:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 10: return [2 /*return*/];
            }
        });
    }); };
    // Fetch products from API (Admin Panel - always bypass cache for fresh data)
    var fetchProducts = function () { return __awaiter(void 0, void 0, void 0, function () {
        var timestamp, response, data, err_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    console.log('🔄 [Frontend] Fetching products from API (admin mode - bypassing cache)...');
                    setLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 6, 7, 8]);
                    timestamp = new Date().getTime();
                    return [4 /*yield*/, fetch("/api/products?admin=true&t=".concat(timestamp), {
                            cache: 'no-store',
                            headers: {
                                'Cache-Control': 'no-cache, no-store, must-revalidate',
                                'Pragma': 'no-cache'
                            }
                        })];
                case 2:
                    response = _a.sent();
                    if (!response.ok) return [3 /*break*/, 4];
                    return [4 /*yield*/, response.json()];
                case 3:
                    data = _a.sent();
                    console.log("\u2705 [Frontend] Received ".concat(data.length, " products from API (fresh from S3)"));
                    console.log('📋 [Frontend] First product:', data[0]);
                    setProducts(data);
                    return [3 /*break*/, 5];
                case 4:
                    setError('Failed to fetch products');
                    _a.label = 5;
                case 5: return [3 /*break*/, 8];
                case 6:
                    err_3 = _a.sent();
                    console.error('❌ [Frontend] Fetch error:', err_3);
                    setError('Network error');
                    return [3 /*break*/, 8];
                case 7:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 8: return [2 /*return*/];
            }
        });
    }); };
    // Force cache refresh for all users
    var handleApplyChanges = function () { return __awaiter(void 0, void 0, void 0, function () {
        var token, response, result, errorData, err_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 7, 8, 9]);
                    console.log('🔄 [Frontend] Applying changes - forcing cache refresh...');
                    token = localStorage.getItem('redaktor_token');
                    if (!token) {
                        setError('Authentication required. Please log in again.');
                        setLoading(false);
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, fetch('/api/products/force-cache-refresh', {
                            method: 'POST',
                            headers: {
                                'Authorization': "Bearer ".concat(token),
                                'Content-Type': 'application/json'
                            }
                        })];
                case 2:
                    response = _a.sent();
                    if (!response.ok) return [3 /*break*/, 4];
                    return [4 /*yield*/, response.json()];
                case 3:
                    result = _a.sent();
                    console.log('✅ [Frontend] Cache refreshed:', result);
                    setMessage("Changes applied! Cache refreshed with ".concat(result.productCount, " products."));
                    return [3 /*break*/, 6];
                case 4: return [4 /*yield*/, response.json()];
                case 5:
                    errorData = _a.sent();
                    setError(errorData.message || 'Failed to refresh cache');
                    _a.label = 6;
                case 6: return [3 /*break*/, 9];
                case 7:
                    err_4 = _a.sent();
                    console.error('❌ [Frontend] Apply changes error:', err_4);
                    setError('Network error while applying changes');
                    return [3 /*break*/, 9];
                case 8:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 9: return [2 /*return*/];
            }
        });
    }); };
    // Delete product
    var handleDelete = function (productId) { return __awaiter(void 0, void 0, void 0, function () {
        var token, response, errorData, err_5;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!confirm('Are you sure you want to delete this product?'))
                        return [2 /*return*/];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 7, , 8]);
                    token = localStorage.getItem('redaktor_token');
                    if (!token) {
                        setError('Authentication required. Please log in again.');
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, fetch("/api/products/".concat(productId), {
                            method: 'DELETE',
                            headers: {
                                'Authorization': "Bearer ".concat(token),
                                'Content-Type': 'application/json'
                            }
                        })];
                case 2:
                    response = _a.sent();
                    if (!response.ok) return [3 /*break*/, 4];
                    setMessage('Product deleted successfully!');
                    // Immediately refresh product list (bypasses cache, gets fresh S3 data)
                    console.log('🔄 [Frontend] Refreshing product list after delete...');
                    return [4 /*yield*/, fetchProducts()];
                case 3:
                    _a.sent();
                    return [3 /*break*/, 6];
                case 4: return [4 /*yield*/, response.json()];
                case 5:
                    errorData = _a.sent();
                    setError(errorData.message || 'Failed to delete product');
                    _a.label = 6;
                case 6: return [3 /*break*/, 8];
                case 7:
                    err_5 = _a.sent();
                    setError('Network error');
                    return [3 /*break*/, 8];
                case 8: return [2 /*return*/];
            }
        });
    }); };
    // Edit product
    var handleEdit = function (product) {
        var _a, _b;
        console.log('🔄 [Frontend] Editing product:', {
            id: product.id,
            name: product.name,
            nameBg: product.nameBg,
            year: product.year,
            description: ((_a = product.description) === null || _a === void 0 ? void 0 : _a.substring(0, 50)) + '...',
            descriptionBg: ((_b = product.descriptionBg) === null || _b === void 0 ? void 0 : _b.substring(0, 50)) + '...'
        });
        setEditingProduct(product);
        setFormData({
            name: product.name || '',
            nameBg: product.nameBg || '',
            year: product.year || '',
            description: product.description || '',
            descriptionBg: product.descriptionBg || '',
            type: product.type || 'Red Wine',
            region: product.region || 'Bulgaria',
            alcoholContent: product.alcoholContent || '',
            servingTemperature: product.servingTemperature || '',
            priceEUR: product.priceEUR || 0,
            image: null
        });
        setPromoForm(promoFormFromProduct(product));
        setActiveTab('edit');
    };
    // Reset form
    var resetForm = function () {
        setFormData({
            name: '',
            nameBg: '',
            year: new Date().getFullYear(),
            description: '',
            descriptionBg: '',
            type: 'Red Wine',
            region: 'Bulgaria',
            alcoholContent: '13.0%',
            servingTemperature: '16-18°C',
            priceEUR: 18.00,
            image: null
        });
        setPromoForm(emptyPromoForm());
        setEditingProduct(null);
        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
    };
    var renderPriceFields = function () {
        return (_jsxs(_Fragment, { children: [_jsx("div", { className: "form-row", children: _jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: "priceEUR", children: "Price (EUR) *" }), _jsx("input", { type: "number", id: "priceEUR", name: "priceEUR", value: formData.priceEUR, onChange: handleInputChange, step: "0.01", min: "0", required: true })] }) }), _jsx(PromoFields, { regularPrice: formData.priceEUR || 0, value: promoForm, onChange: setPromoForm })] }));
    };
    // ── Events helpers ────────────────────────────────────────
    var fetchEvents = function () { return __awaiter(void 0, void 0, void 0, function () {
        var token, res, data, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setEventsLoading(true);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 4, 5, 6]);
                    token = localStorage.getItem('redaktor_token');
                    return [4 /*yield*/, fetch('/api/wine-events?all=true', {
                            headers: token ? { 'Authorization': "Bearer ".concat(token) } : {},
                        })];
                case 2:
                    res = _b.sent();
                    return [4 /*yield*/, res.json()];
                case 3:
                    data = _b.sent();
                    setEvents(Array.isArray(data) ? data : []);
                    return [3 /*break*/, 6];
                case 4:
                    _a = _b.sent();
                    setEventsError('Failed to load events');
                    return [3 /*break*/, 6];
                case 5:
                    setEventsLoading(false);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var handleEventFormChange = function (e) {
        var _a = e.target, name = _a.name, value = _a.value;
        setEventForm(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[name] = value, _a)));
        });
    };
    var handleEventSubmit = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var token, url, method, res, err, err_6;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    e.preventDefault();
                    if (!eventForm.name.trim() || !eventForm.nameBg.trim() || !eventForm.date ||
                        !eventForm.town.trim() || !eventForm.townBg.trim() ||
                        !eventForm.location.trim() || !eventForm.locationBg.trim()) {
                        setEventsError('All name, town and location fields (EN + BG) are required');
                        return [2 /*return*/];
                    }
                    setEventsLoading(true);
                    setEventsMessage('');
                    setEventsError('');
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 6, 7, 8]);
                    token = localStorage.getItem('redaktor_token');
                    url = editingEvent ? "/api/wine-events/".concat(editingEvent.id) : '/api/wine-events';
                    method = editingEvent ? 'PUT' : 'POST';
                    return [4 /*yield*/, fetch(url, {
                            method: method,
                            headers: { 'Content-Type': 'application/json', 'Authorization': "Bearer ".concat(token) },
                            body: JSON.stringify(eventForm),
                        })];
                case 2:
                    res = _a.sent();
                    if (!!res.ok) return [3 /*break*/, 4];
                    return [4 /*yield*/, res.json()];
                case 3:
                    err = _a.sent();
                    throw new Error(err.message || 'Failed to save event');
                case 4:
                    setEventsMessage(editingEvent ? 'Event updated!' : 'Event added!');
                    setEventForm(emptyEventForm());
                    setEditingEvent(null);
                    return [4 /*yield*/, fetchEvents()];
                case 5:
                    _a.sent();
                    return [3 /*break*/, 8];
                case 6:
                    err_6 = _a.sent();
                    setEventsError(err_6.message || 'Error saving event');
                    return [3 /*break*/, 8];
                case 7:
                    setEventsLoading(false);
                    return [7 /*endfinally*/];
                case 8: return [2 /*return*/];
            }
        });
    }); };
    var handleDeleteEvent = function (id) { return __awaiter(void 0, void 0, void 0, function () {
        var token, res, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!window.confirm('Delete this event?'))
                        return [2 /*return*/];
                    setEventsLoading(true);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 4, 5, 6]);
                    token = localStorage.getItem('redaktor_token');
                    return [4 /*yield*/, fetch("/api/wine-events/".concat(id), {
                            method: 'DELETE',
                            headers: { 'Authorization': "Bearer ".concat(token) },
                        })];
                case 2:
                    res = _b.sent();
                    if (!res.ok)
                        throw new Error('Failed to delete');
                    setEventsMessage('Event deleted');
                    return [4 /*yield*/, fetchEvents()];
                case 3:
                    _b.sent();
                    return [3 /*break*/, 6];
                case 4:
                    _a = _b.sent();
                    setEventsError('Failed to delete event');
                    return [3 /*break*/, 6];
                case 5:
                    setEventsLoading(false);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var handleEditEvent = function (ev) {
        setEditingEvent(ev);
        setEventForm({
            name: ev.name,
            nameBg: ev.nameBg || '',
            date: ev.date,
            time: ev.time || '',
            town: ev.town,
            townBg: ev.townBg || '',
            location: ev.location,
            locationBg: ev.locationBg || '',
            link: ev.link || '',
            linkType: ev.linkType || 'website',
        });
        setActiveTab('add-event');
    };
    // ── render ────────────────────────────────────────────────
    return (_jsx("div", { className: "admin-panel-overlay", children: _jsxs("div", { className: "admin-panel", children: [_jsxs("div", { className: "admin-header", children: [_jsx("h2", { children: "\uD83C\uDF77 Wine Management Panel" }), _jsx("button", { className: "close-btn", onClick: onClose, children: "\u00D7" })] }), _jsxs("div", { className: "admin-tabs", children: [_jsx("button", { className: "tab-btn ".concat(activeTab === 'add' ? 'active' : ''), onClick: function () { return setActiveTab('add'); }, children: "Add New Wine" }), _jsx("button", { className: "tab-btn ".concat(activeTab === 'edit' ? 'active' : ''), onClick: function () { return setActiveTab('edit'); }, disabled: !editingProduct, children: "Edit Wine" }), _jsx("button", { className: "tab-btn ".concat(activeTab === 'list' ? 'active' : ''), onClick: function () {
                                setActiveTab('list');
                                fetchProducts();
                            }, children: "Manage Wines" }), _jsx("button", { className: "tab-btn ".concat(activeTab === 'promotions' ? 'active' : ''), onClick: function () {
                                setActiveTab('promotions');
                                setMessage('');
                                setError('');
                                fetchProducts();
                            }, children: "Manage Promotions" }), _jsx("button", { className: "tab-btn ".concat(activeTab === 'add-event' ? 'active' : ''), onClick: function () { setActiveTab('add-event'); setEventsMessage(''); setEventsError(''); }, children: "Add New Event" }), _jsx("button", { className: "tab-btn ".concat(activeTab === 'manage-events' ? 'active' : ''), onClick: function () {
                                setActiveTab('manage-events');
                                fetchEvents();
                            }, children: "Manage Events" })] }), message && _jsx("div", { className: "success-message", children: message }), error && _jsx("div", { className: "error-message", children: error }), activeTab === 'add' && (_jsxs("form", { onSubmit: handleSubmit, className: "admin-form", children: [_jsx("h3", { children: "Add New Wine Product" }), _jsxs("div", { className: "form-row", children: [_jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: "name", children: "Name (English) *" }), _jsx("input", { type: "text", id: "name", name: "name", value: formData.name, onChange: handleInputChange, required: true, placeholder: "e.g., Merlot Reserve 2019" })] }), _jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: "nameBg", children: "Name (Bulgarian) *" }), _jsx("input", { type: "text", id: "nameBg", name: "nameBg", value: formData.nameBg, onChange: handleInputChange, required: true, placeholder: "e.g., \u041C\u0435\u0440\u043B\u043E \u0420\u0435\u0437\u0435\u0440\u0432 2019" })] })] }), _jsxs("div", { className: "form-row", children: [_jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: "year", children: "Vintage Year" }), _jsx("input", { type: "text", id: "year", name: "year", value: formData.year, onChange: handleInputChange, placeholder: "e.g., 2020" })] }), _jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: "type", children: "Wine Type" }), _jsxs("select", { id: "type", name: "type", value: formData.type, onChange: handleInputChange, children: [_jsx("option", { value: "Red Wine", children: "Red Wine" }), _jsx("option", { value: "White Wine", children: "White Wine" }), _jsx("option", { value: "Ros\u00E9 Wine", children: "Ros\u00E9 Wine" }), _jsx("option", { value: "Sparkling Wine", children: "Sparkling Wine" })] })] })] }), _jsxs("div", { className: "form-row", children: [_jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: "region", children: "Region" }), _jsx("input", { type: "text", id: "region", name: "region", value: formData.region, onChange: handleInputChange, placeholder: "e.g., Bulgaria" })] }), _jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: "alcoholContent", children: "Alcohol Content" }), _jsx("input", { type: "text", id: "alcoholContent", name: "alcoholContent", value: formData.alcoholContent, onChange: handleInputChange, placeholder: "e.g., 13.5%" })] })] }), _jsx("div", { className: "form-row", children: _jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: "servingTemperature", children: "Serving Temperature" }), _jsx("input", { type: "text", id: "servingTemperature", name: "servingTemperature", value: formData.servingTemperature, onChange: handleInputChange, placeholder: "e.g., 16-18\u00B0C" })] }) }), renderPriceFields(), _jsxs("div", { className: "form-group full-width", children: [_jsx("label", { htmlFor: "description", children: "Description (English) *" }), _jsx("textarea", { id: "description", name: "description", value: formData.description, onChange: handleInputChange, required: true, rows: 6, placeholder: "Describe the wine's characteristics, flavors, and aging...\n\nFormatting tips:\n- Use blank lines for paragraphs\n- Start lines with - or \u2022 for bullet points" })] }), _jsxs("div", { className: "form-group full-width", children: [_jsx("label", { htmlFor: "descriptionBg", children: "Description (Bulgarian) *" }), _jsx("textarea", { id: "descriptionBg", name: "descriptionBg", value: formData.descriptionBg, onChange: handleInputChange, required: true, rows: 6, placeholder: "\u041E\u043F\u0438\u0448\u0435\u0442\u0435 \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A\u0438\u0442\u0435, \u0432\u043A\u0443\u0441\u043E\u0432\u0435\u0442\u0435 \u0438 \u043E\u0442\u043B\u0435\u0436\u0430\u0432\u0430\u043D\u0435\u0442\u043E \u043D\u0430 \u0432\u0438\u043D\u043E\u0442\u043E...\n\n\u0421\u044A\u0432\u0435\u0442\u0438 \u0437\u0430 \u0444\u043E\u0440\u043C\u0430\u0442\u0438\u0440\u0430\u043D\u0435:\n- \u0418\u0437\u043F\u043E\u043B\u0437\u0432\u0430\u0439\u0442\u0435 \u043F\u0440\u0430\u0437\u043D\u0438 \u0440\u0435\u0434\u043E\u0432\u0435 \u0437\u0430 \u043F\u0430\u0440\u0430\u0433\u0440\u0430\u0444\u0438\n- \u0417\u0430\u043F\u043E\u0447\u043D\u0435\u0442\u0435 \u0440\u0435\u0434\u043E\u0432\u0435 \u0441 - \u0438\u043B\u0438 \u2022 \u0437\u0430 \u0442\u043E\u0447\u043A\u0438" })] }), _jsxs("div", { className: "form-group full-width", children: [_jsx("label", { htmlFor: "image", children: "Product Image *" }), _jsx("input", { ref: fileInputRef, type: "file", id: "image", name: "image", onChange: handleFileChange, accept: "image/*", required: true }), _jsx("small", { children: "Accepted formats: JPG, PNG, GIF, WebP (max 5MB)" })] }), _jsxs("div", { className: "form-actions", children: [_jsx("button", { type: "submit", disabled: loading, className: "submit-btn", children: loading ? 'Adding...' : 'Add Wine Product' }), _jsx("button", { type: "button", onClick: resetForm, className: "reset-btn", children: "Reset Form" })] })] })), activeTab === 'edit' && editingProduct && (_jsxs("form", { onSubmit: handleUpdate, className: "admin-form", children: [_jsxs("h3", { children: ["Edit Wine Product: ", escapeHtml(editingProduct.name)] }), _jsxs("div", { className: "form-row", children: [_jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: "name", children: "Name (English)" }), _jsx("input", { type: "text", id: "name", name: "name", value: formData.name, onChange: handleInputChange, placeholder: "e.g., Merlot Reserve 2019" })] }), _jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: "nameBg", children: "Name (Bulgarian)" }), _jsx("input", { type: "text", id: "nameBg", name: "nameBg", value: formData.nameBg, onChange: handleInputChange, placeholder: "e.g., \u041C\u0435\u0440\u043B\u043E \u0420\u0435\u0437\u0435\u0440\u0432 2019" })] })] }), _jsxs("div", { className: "form-row", children: [_jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: "year", children: "Vintage Year" }), _jsx("input", { type: "text", id: "year", name: "year", value: formData.year, onChange: handleInputChange, placeholder: "e.g., 2020" })] }), _jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: "type", children: "Wine Type" }), _jsxs("select", { id: "type", name: "type", value: formData.type, onChange: handleInputChange, children: [_jsx("option", { value: "Red Wine", children: "Red Wine" }), _jsx("option", { value: "White Wine", children: "White Wine" }), _jsx("option", { value: "Ros\u00E9 Wine", children: "Ros\u00E9 Wine" }), _jsx("option", { value: "Sparkling Wine", children: "Sparkling Wine" })] })] })] }), _jsxs("div", { className: "form-row", children: [_jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: "region", children: "Region" }), _jsx("input", { type: "text", id: "region", name: "region", value: formData.region, onChange: handleInputChange, placeholder: "e.g., Bulgaria" })] }), _jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: "alcoholContent", children: "Alcohol Content" }), _jsx("input", { type: "text", id: "alcoholContent", name: "alcoholContent", value: formData.alcoholContent, onChange: handleInputChange, placeholder: "e.g., 13.5%" })] })] }), _jsx("div", { className: "form-row", children: _jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: "servingTemperature", children: "Serving Temperature" }), _jsx("input", { type: "text", id: "servingTemperature", name: "servingTemperature", value: formData.servingTemperature, onChange: handleInputChange, placeholder: "e.g., 16-18\u00B0C" })] }) }), renderPriceFields(), _jsxs("div", { className: "form-group full-width", children: [_jsx("label", { htmlFor: "description", children: "Description (English)" }), _jsx("textarea", { id: "description", name: "description", value: formData.description, onChange: handleInputChange, rows: 6, placeholder: "Describe the wine's characteristics, flavors, and aging...\n\nFormatting tips:\n- Use blank lines for paragraphs\n- Start lines with - or \u2022 for bullet points" })] }), _jsxs("div", { className: "form-group full-width", children: [_jsx("label", { htmlFor: "descriptionBg", children: "Description (Bulgarian)" }), _jsx("textarea", { id: "descriptionBg", name: "descriptionBg", value: formData.descriptionBg, onChange: handleInputChange, rows: 6, placeholder: "\u041E\u043F\u0438\u0448\u0435\u0442\u0435 \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A\u0438\u0442\u0435, \u0432\u043A\u0443\u0441\u043E\u0432\u0435\u0442\u0435 \u0438 \u043E\u0442\u043B\u0435\u0436\u0430\u0432\u0430\u043D\u0435\u0442\u043E \u043D\u0430 \u0432\u0438\u043D\u043E\u0442\u043E...\n\n\u0421\u044A\u0432\u0435\u0442\u0438 \u0437\u0430 \u0444\u043E\u0440\u043C\u0430\u0442\u0438\u0440\u0430\u043D\u0435:\n- \u0418\u0437\u043F\u043E\u043B\u0437\u0432\u0430\u0439\u0442\u0435 \u043F\u0440\u0430\u0437\u043D\u0438 \u0440\u0435\u0434\u043E\u0432\u0435 \u0437\u0430 \u043F\u0430\u0440\u0430\u0433\u0440\u0430\u0444\u0438\n- \u0417\u0430\u043F\u043E\u0447\u043D\u0435\u0442\u0435 \u0440\u0435\u0434\u043E\u0432\u0435 \u0441 - \u0438\u043B\u0438 \u2022 \u0437\u0430 \u0442\u043E\u0447\u043A\u0438" })] }), _jsxs("div", { className: "form-group full-width", children: [_jsx("label", { htmlFor: "image", children: "New Product Image (optional)" }), _jsx("input", { ref: fileInputRef, type: "file", id: "image", name: "image", onChange: handleFileChange, accept: "image/*" }), _jsx("small", { children: "Leave empty to keep current image. Accepted formats: JPG, PNG, GIF, WebP (max 5MB)" })] }), _jsxs("div", { className: "form-actions", children: [_jsx("button", { type: "submit", disabled: loading, className: "submit-btn", children: loading ? 'Updating...' : 'Update Wine Product' }), _jsx("button", { type: "button", onClick: resetForm, className: "reset-btn", children: "Cancel Edit" })] })] })), activeTab === 'promotions' && (_jsx(PromotionsManager, { products: products, loading: loading, onSaved: function (savedMessage) { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    setError('');
                                    setMessage(savedMessage);
                                    return [4 /*yield*/, fetchProducts()];
                                case 1:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); }, onError: setError })), activeTab === 'list' && (_jsxs("div", { className: "products-list", children: [_jsxs("div", { style: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }, children: [_jsx("h3", { children: "Manage Wine Products" }), _jsx("button", { onClick: handleApplyChanges, className: "apply-changes-btn", disabled: loading, title: "Force cache refresh for all users - makes changes visible on the public site immediately", children: "\uD83D\uDD04 Apply Changes" })] }), loading ? (_jsx("div", { className: "loading", children: "Loading products..." })) : products.length === 0 ? (_jsxs("div", { className: "no-products", children: [_jsx("p", { children: "No products found in S3 bucket." }), _jsx("p", { children: "Add some products using the \"Add New Wine\" tab!" })] })) : (_jsx("div", { className: "products-grid", children: products.map(function (product) { return (_jsxs("div", { className: "product-item", children: [_jsx("img", { src: product.imageUrl, alt: product.name, className: "product-thumbnail", onError: function (e) {
                                            var target = e.target;
                                            target.src = '/api/products/default-image';
                                        } }), _jsxs("div", { className: "product-info", children: [_jsx("h4", { children: escapeHtml(product.nameBg || 'No Bulgarian Name') }), _jsx("h5", { style: { color: '#7B2323', fontSize: '0.9rem', margin: '4px 0', fontWeight: '500' }, children: escapeHtml(product.name || 'No English Name') }), (function () {
                                                var activePromo = getActivePromo(product);
                                                return activePromo ? (_jsxs(_Fragment, { children: [_jsxs("p", { className: "product-price", children: [_jsx("s", { children: formatEUR(product.priceEUR) }), " ", formatEUR(activePromo.price)] }), _jsxs("p", { className: "product-promo", children: ["-", activePromo.percent, "% until ", formatPromoDate(activePromo.endsAt)] })] })) : (_jsx("p", { className: "product-price", children: formatEUR(product.priceEUR) }));
                                            })(), _jsx("p", { className: "product-type", children: escapeHtml(product.type) }), product.year && (_jsx("p", { style: { color: '#5D3A3A', fontSize: '0.8rem', margin: '4px 0', fontWeight: '500' }, children: product.year }))] }), _jsxs("div", { className: "product-actions", children: [_jsx("button", { onClick: function () { return handleEdit(product); }, className: "edit-btn", children: "Edit" }), _jsx("button", { onClick: function () { return handleDelete(product.id); }, className: "delete-btn", children: "Delete" })] })] }, product.id)); }) }))] })), activeTab === 'add-event' && (_jsxs("form", { onSubmit: handleEventSubmit, className: "admin-form", children: [_jsx("h3", { children: editingEvent ? 'Edit Event' : 'Add New Event' }), eventsMessage && _jsx("div", { className: "success-message", children: eventsMessage }), eventsError && _jsx("div", { className: "error-message", children: eventsError }), _jsxs("div", { className: "form-row", children: [_jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: "ev-name", children: "Event Name (English) *" }), _jsx("input", { type: "text", id: "ev-name", name: "name", value: eventForm.name, onChange: handleEventFormChange, placeholder: "e.g. Sofia Wine Fest", required: true })] }), _jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: "ev-nameBg", children: "\u0418\u043C\u0435 \u043D\u0430 \u0441\u044A\u0431\u0438\u0442\u0438\u0435\u0442\u043E (\u0411\u0413) *" }), _jsx("input", { type: "text", id: "ev-nameBg", name: "nameBg", value: eventForm.nameBg, onChange: handleEventFormChange, placeholder: "\u043D\u0430\u043F\u0440. \u0424\u0435\u0441\u0442 \u043D\u0430 \u0432\u0438\u043D\u043E\u0442\u043E", required: true })] })] }), _jsxs("div", { className: "form-row", children: [_jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: "ev-date", children: "Date *" }), _jsx("input", { type: "date", id: "ev-date", name: "date", value: eventForm.date, onChange: handleEventFormChange, required: true })] }), _jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: "ev-time", children: "Time (Bulgarian time, 24h)" }), _jsx("input", { type: "time", id: "ev-time", name: "time", value: eventForm.time, onChange: handleEventFormChange, step: "60" })] })] }), _jsxs("div", { className: "form-row", children: [_jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: "ev-town", children: "Town (English) *" }), _jsx("input", { type: "text", id: "ev-town", name: "town", value: eventForm.town, onChange: handleEventFormChange, placeholder: "e.g. Sofia", required: true })] }), _jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: "ev-townBg", children: "\u0413\u0440\u0430\u0434 (\u0411\u0413) *" }), _jsx("input", { type: "text", id: "ev-townBg", name: "townBg", value: eventForm.townBg, onChange: handleEventFormChange, placeholder: "\u043D\u0430\u043F\u0440. \u0421\u043E\u0444\u0438\u044F", required: true })] })] }), _jsxs("div", { className: "form-row", children: [_jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: "ev-location", children: "Venue (English) *" }), _jsx("input", { type: "text", id: "ev-location", name: "location", value: eventForm.location, onChange: handleEventFormChange, placeholder: "e.g. NDK, Hall 1", required: true })] }), _jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: "ev-locationBg", children: "\u0417\u0430\u043B\u0430 / \u041B\u043E\u043A\u0430\u0446\u0438\u044F (\u0411\u0413) *" }), _jsx("input", { type: "text", id: "ev-locationBg", name: "locationBg", value: eventForm.locationBg, onChange: handleEventFormChange, placeholder: "\u043D\u0430\u043F\u0440. \u041D\u0414\u041A, \u0437\u0430\u043B\u0430 1", required: true })] })] }), _jsxs("div", { className: "form-row", children: [_jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: "ev-linkType", children: "Link Type" }), _jsxs("select", { id: "ev-linkType", name: "linkType", value: eventForm.linkType, onChange: handleEventFormChange, children: [_jsx("option", { value: "website", children: "Website" }), _jsx("option", { value: "facebook", children: "Facebook" }), _jsx("option", { value: "instagram", children: "Instagram" })] })] }), _jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: "ev-link", children: "Link URL" }), _jsx("input", { type: "url", id: "ev-link", name: "link", value: eventForm.link, onChange: handleEventFormChange, placeholder: "https://..." })] })] }), _jsxs("div", { className: "form-actions", children: [_jsx("button", { type: "submit", disabled: eventsLoading, className: "submit-btn", children: eventsLoading ? 'Saving...' : editingEvent ? 'Update Event' : 'Add Event' }), editingEvent && (_jsx("button", { type: "button", className: "reset-btn", onClick: function () { setEditingEvent(null); setEventForm(emptyEventForm()); setEventsMessage(''); setEventsError(''); }, children: "Cancel Edit" }))] })] })), activeTab === 'manage-events' && (_jsxs("div", { className: "products-list", children: [_jsx("h3", { children: "Manage Upcoming Events" }), eventsMessage && _jsx("div", { className: "success-message", children: eventsMessage }), eventsError && _jsx("div", { className: "error-message", children: eventsError }), eventsLoading ? (_jsx("div", { className: "loading", children: "Loading events..." })) : events.length === 0 ? (_jsxs("div", { className: "no-products", children: [_jsx("p", { children: "No events found." }), _jsx("p", { children: "Add some events using the \"Add New Event\" tab!" })] })) : (_jsx("div", { className: "products-grid", style: { gridTemplateColumns: '1fr' }, children: events.map(function (ev) { return (_jsxs("div", { className: "product-item", style: { alignItems: 'flex-start' }, children: [_jsxs("div", { className: "product-info", style: { flex: 1 }, children: [_jsx("h4", { children: escapeHtml(ev.nameBg || ev.name) }), _jsx("h5", { style: { color: '#7B2323', fontSize: '0.9rem', margin: '4px 0', fontWeight: '500' }, children: escapeHtml(ev.name) }), _jsxs("p", { className: "product-type", children: [ev.date, ev.time ? " \u00B7 ".concat(ev.time) : ''] }), _jsxs("p", { style: { fontSize: '0.85rem', color: '#5D3A3A', margin: '2px 0 0' }, children: [escapeHtml(ev.townBg || ev.town), " \u00B7 ", escapeHtml(ev.locationBg || ev.location)] }), ev.link && (_jsxs("p", { style: { fontSize: '0.8rem', color: '#888', margin: '3px 0 0' }, children: [ev.linkType, " \u2014 ", _jsx("a", { href: ev.link, target: "_blank", rel: "noopener noreferrer", style: { color: '#7B2323' }, children: ev.link })] }))] }), _jsxs("div", { className: "product-actions", children: [_jsx("button", { onClick: function () { return handleEditEvent(ev); }, className: "edit-btn", children: "Edit" }), _jsx("button", { onClick: function () { return handleDeleteEvent(ev.id); }, className: "delete-btn", children: "Delete" })] })] }, ev.id)); }) }))] }))] }) }));
};
export default AdminPanel;
